var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#586370"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3536 8.15281C17.5488 8.35657 17.5488 8.68691 17.3536 8.89066L10.6869 15.8472C10.4916 16.0509 10.175 16.0509 9.97978 15.8472L6.64645 12.3689C6.45118 12.1652 6.45118 11.8348 6.64645 11.6311C6.84171 11.4273 7.15829 11.4273 7.35355 11.6311L10.3333 14.7404L16.6464 8.15281C16.8417 7.94906 17.1583 7.94906 17.3536 8.15281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconNew);
export default __webpack_public_path__ + "static/media/tick-icon-new.18c836a3372c8741a2c129b300f31932.svg";
export { ForwardRef as ReactComponent };